import { OnInit, Component, Inject, ChangeDetectionStrategy} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppService } from "@irb/app.service";
import { PortfolioService } from "../portfolios/portfolio.service";
import {EditMultiplePortfoliosDialogGridLayoutService} from "@irb/irb-clients/edit-multiple-portfolios-dialog/edit-multiple-portfolios-dialog.grid-layout.service";

@Component({ standalone: false,
    selector: 'edit-multiple-portfolios-dialog',
    templateUrl: './edit-multiple-portfolios-dialog.component.html',
    styleUrls: ['./edit-multiple-portfolios-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class EditMultiplePortfoliosDialogComponent implements OnInit {
    portfolioTarget = new FormControl();
    portfolios: Array<number>;
    editMultiplePFContinueFunction: Function;
    grid: any;
    gridOptions: any;

    constructor(public dialogRef: MatDialogRef<EditMultiplePortfoliosDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public mdd: any,
        private as: AppService,
        private readonly portfolioService: PortfolioService,
        private gls: EditMultiplePortfoliosDialogGridLayoutService) {
    }

    ngOnInit(): void {
        let columns: any = this.gls.getColumnDefs();
        if (this.mdd.noTotalAccount) {
            columns[1].hide = true;
            columns[0].width = 650;
        }
        this.gridOptions = {
            columnDefs: columns,
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
            context: { componentParent: this }
        };

        this.portfolios = this.mdd.portfolios as Array<number>;
        this.editMultiplePFContinueFunction = this.mdd.editMultiplePFContinueFunction || null;
    }

    close() {
        this.dialogRef.close();
    }

    editSelectedPortfolios() {
        this.editMultiplePFContinueFunction();
        this.close();
    }
    onGridReady(params: any) {
        this.grid = params;
    }
}
